import { BaJwt } from "@oiambk/oiam-oauth-types";
export class JwtUtil {
    /**
     * Get the payload from a jwt-string
     * @param tokenEventType
     */
    static parseBAJwt(tokenEventType) {
        return tokenEventType?.jwt ? new BaJwt(tokenEventType.jwt) : null;
    }
    /**
     * Checks if the tokenEvent has a valid token with jwt-version 2.9
     *
     * returns the result and optionally the jwt, if found.
     *
     * @param tokenEvent
     */
    static validateJwt = (tokenEvent) => {
        // if the token is empty, the user is not logged in yet
        if (tokenEvent.detail?.jwt) {
            const jwt = JwtUtil.parseBAJwt(tokenEvent.detail);
            if (jwt?.payload?.['jwt-version'] &&
                typeof jwt.payload['jwt-version'] === 'string' &&
                !jwt.payload['jwt-version'].startsWith('2.4')) {
                return { isValidJwt: true, jwt: jwt };
            }
        }
        return { isValidJwt: false };
    };
    static parseGroupsToValidatedArray(valueFromToken) {
        const parsedGroups = valueFromToken ?? [];
        let groupsToCheck = [];
        if (typeof parsedGroups === 'string') {
            groupsToCheck.push(parsedGroups);
        }
        else {
            groupsToCheck.push(...parsedGroups);
        }
        // a group looks like this urn:barol:ubvonline:admin
        groupsToCheck = groupsToCheck.map((group) => group.split(':').slice(-1)[0]);
        const groupsToReturn = [];
        for (let group of groupsToCheck) {
            if (this.typeGuardGroupTypes(group)) {
                groupsToReturn.push(group);
            }
        }
        return groupsToReturn;
    }
    static parseAoboToFachschluessel(aobo) {
        // Aufbau eines aobo: urn:bafor:VERFAHREN:OBJEKTTYP:SCHLÜSSELTYP:SCHLÜSSEL
        const fachschluessel = {
            verfahren: '',
            objektTyp: '',
            schluesselTyp: '',
            schluessel: '',
        };
        if (aobo === '') {
            return fachschluessel;
        }
        const splitAobo = aobo.split(':');
        if (splitAobo.length != 6) {
            console.error('unexpected length of acting on behalf of', aobo);
            return fachschluessel;
        }
        if (this.typeGuardVerfahrenTypes(splitAobo[2])) {
            fachschluessel.verfahren = splitAobo[2];
        }
        if (this.typeGuardObjektTypes(splitAobo[3])) {
            fachschluessel.objektTyp = splitAobo[3];
        }
        if (this.typeGuardSchluesseltypTypes(splitAobo[4])) {
            fachschluessel.schluesselTyp = splitAobo[4];
        }
        fachschluessel.schluessel = splitAobo[5];
        return fachschluessel;
    }
    static typeGuardObjektTypes(value) {
        return value === 'person' || value === 'kindergeldfall' || value === 'betrieb' || value === 'partner';
    }
    static typeGuardGroupTypes(value) {
        return value === 'bevollmaechtigte' || value === 'admin' || value === 'zuwanderungsinteressierter';
    }
    static typeGuardVerfahrenTypes(value) {
        return value === 'step' || value === 'ubvonline' || value === 'pmventerprise' || value === 'kiwi';
    }
    static typeGuardSchluesseltypTypes(value) {
        return (value === 'kundennummer' || value === 'kindergeldnummer' || value === 'partnerid' || value === 'mitarbeiterid');
    }
}
